// UsersList.js 
import { useGetUsersQuery } from "./usersApiSlice"
import User from './User'
import useTitle from "../../hooks/useTitle"
import PulseLoader from 'react-spinners/PulseLoader'
import { Link } from "react-router-dom"

const UsersList = () => {
    useTitle('Nhà đẹp - Danh sách người dùng')

    const {
        data: users,
        isLoading,
        isSuccess,
        isError,
        error
    } = useGetUsersQuery('usersList', {
        pollingInterval: 60000,
        refetchOnFocus: true,
        refetchOnMountOrArgChange: true
    })

    let content

    if (isLoading) content = <div className="text-center py-5"><PulseLoader color={"#0d6efd"} /></div>
    if (isError) content = <div className="alert alert-danger text-center">Lỗi: {error?.data?.message}</div>

    if (isSuccess) {
        const { ids } = users

        content = (
            <div className="container-fluid py-4">
                <div className="row justify-content-center">
                    <div className="col-12 col-lg-8 col-xl-6">
                        <div className="card shadow border-0">
                            <div className="card-header bg-primary text-white d-flex justify-content-between align-items-center">
                                <h4 className="mb-0">
                                    <i className="bi bi-person-lines-fill me-2"></i>
                                    Danh sách người dùng
                                </h4>
                            </div>
                            <div className="card-body p-0">
                                <div className="table-responsive">
                                    <table className="table table-hover mb-0 align-middle">
                                        <thead className="table-light">
                                            <tr>
                                                <th className="text-center">Tài khoản</th>
                                                <th className="text-center">Vai trò</th>
                                                <th className="text-center">Trạng thái</th>
                                                <th className="text-center">Xem SĐT</th>
                                                <th className="text-center">Hành động</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {ids?.length ? (
                                                ids.map(userId => <User key={userId} userId={userId} />)
                                            ) : (
                                                <tr>
                                                    <td colSpan="4" className="text-center py-5 text-muted">
                                                        <i className="fas fa-inbox fa-2x mb-3 d-block"></i>
                                                        Chưa có người dùng nào
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                            <div className="card-footer bg-light text-white d-flex justify-content-between align-items-center">
                                <Link to="/dash/users/new" className="btn btn-success btn-sm">
                                    <i className="bi bi-person-plus me-2"></i>
                                    Thêm người dùng
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }

    return content
}

export default UsersList